import DefaultTheme from 'assets/themes/default';
const VariationTheme2 =  JSON.parse(JSON.stringify(DefaultTheme));

VariationTheme2.header.bgColor = VariationTheme2.palette.primary.main;
VariationTheme2.header.color = 'white';

export default VariationTheme2;
